export default __webpack_public_path__ + "static/media/quiz-bg.453f809d.png";